import josephImg from "../Images/Speakers/Joseph.jpeg";
import kulaniImg from "../Images/Speakers/Kulani.jpeg";
import langaImg from "../Images/Speakers/Langa.jpeg";
import mphoImg from "../Images/Speakers/Mpho.jpeg";
import buhleImg from "../Images/Speakers/BuhleThela.jpeg";
import mikeImg from "../Images/Speakers/Mike.jpg"; // FIXED .jpg
import xoliImg from "../Images/Speakers/Xoli.jpeg";
import mthunziImg from "../Images/Speakers/Mthunzi.jpeg";

function Speakers() {
  const speakers = [
    { name: "Joseph Makola", image: josephImg },
    { name: "PS. Mthunzi Namba", image: mthunziImg }, // moved right after Joseph
    { name: "PS. Kulani Muthembi", image: kulaniImg },
    { name: "PS. Langa Mbonambi", image: langaImg },
    { name: "PS. Mpho Molaba", image: mphoImg },
    { name: "PS. Buhle Thela", image: buhleImg },
    { name: "PS. Michael David", image: mikeImg },
    { name: "Xoli Thabethe", image: xoliImg }
  ];

  return (
    <section
      id="speakers"
      style={{
        padding: "80px 20px",
        textAlign: "center",
        background: "white"
      }}
    >
      <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>
        Speakers
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "25px",
          flexWrap: "wrap"
        }}
      >
        {speakers.map((speaker, index) => (
          <div
            key={index}
            style={{
              width: "240px",
              background: "#fafafa",
              borderRadius: "12px",
              overflow: "hidden",
              border: "1px solid #eee",
              boxShadow: "0 6px 18px rgba(0,0,0,0.06)"
            }}
          >
            <div
              style={{
                width: "100%",
                height: "280px",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                paddingTop: "12px",
                background: "#fff"
              }}
            >
              <img
                src={speaker.image}
                alt={speaker.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  borderRadius: "10px"
                }}
              />
            </div>

            <div style={{ padding: "15px" }}>
              <h3 style={{ margin: 0 }}>
                {speaker.name}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Speakers;